export default __webpack_public_path__ + "images/person-target-outline-white.2aaf84dc8e06a410e623df1e9f6e70ad.png";